<template>
  <div class="video_detail"
       :style="{height:windowHeight + 'px'}">
    <loading :active.sync="loading"
             :can-cancel="true"
             :is-full-page="true"></loading>
    <TopAlert></TopAlert>
    <NavBar style="navbar"
            :parentName="'detail'"></NavBar>
    <van-nav-bar
      :border="false"
      class="navBar_setting"
      safe-area-inset-top
      fixed
      @click-left="$router.push('/')"
    >
      <template #left>
        <van-icon name="arrow-left"
                  color="#fff"
                  size="20"></van-icon>
      </template>
    </van-nav-bar>
    <div
      class="video"
      v-bind:style="{'margin-top': isMobileApp? '55px' : 'none'}"
      v-if="currentVideo"
    >
      <!-- <button
        class="home-btn"
        @click="goHome()">
        <img class="home-img"
             src="static/images/home.png">
        <div class="back-to-home">
        <span class="back-to-home-sapn">Back to Home</span></div>
      </button>-->
      <!-- <div v-if="isWebsite && !userInfo"
           class="language-div">
        <b-dropdown text="En/中"
                    right
                    class="language-btn">
          <b-dropdown-item @click="$i18n.locale='en'">English</b-dropdown-item>
          <b-dropdown-item @click="$i18n.locale='cn'">简体中文</b-dropdown-item>
        </b-dropdown>
      </div>-->
      <!-- <div class="profile">
        <Profile :drop_left='true'></Profile>
      </div>-->
      <div v-if="currentVideo.source == 'youtube'">
        <div
          :ref="'video_container_' + currentVideo.id"
          v-bind:class="getVideoClass(currentVideo.id)"
          v-if="!isFullScreen || !enableSubtitleFeature"
        >
          <vytia-player
            v-if="currentVideo.video_type=='Video' || !currentVideo.video_type"
            :ytid="currentVideo.id"
            :ref="'video' + currentVideo.id"
            :player-vars="{controls: 1, fs: iframeFullscreenMode, rel: 0, playsinline: iframeFullscreenMode}"
            :width="videoWidth"
            :height="videoHeight"
            @playing="onPlayVideo(currentVideo.id)"
            @paused="onStopVideo(currentVideo.id)"
          ></vytia-player>
          <vytia-player
            v-if="currentVideo.video_type=='Playlist'"
            :ref="'video' + currentVideo.id"
            :player-vars="{controls: 1, fs: iframeFullscreenMode, rel: 0, listType: 'playlist', list: currentVideo.id, playsinline: iframeFullscreenMode}"
            :width="videoWidth"
            :height="videoHeight"
            @playing="onPlayVideo(currentVideo.id)"
            @paused="onStopVideo(currentVideo.id)"
          ></vytia-player>
        </div>
      </div>
      <div v-if="currentVideo.video_type == 'Live'">
        <div
          id="tx_live_player"
          :style="{width:videoWidth+'px',height:videoHeight+'px',marginBottom:'10px'}"
          v-if="currentVideo.source == 'tencent'"
        ></div>
        <div v-else-if="currentVideo.source == 'bilibili'">
          <video
            :width="videoWidth"
            :height="videoHeight"
            ref="video"
            style="outline:none;"
            controls
          ></video>
        </div>
      </div>
      <div v-else>
        <div
          v-if="currentVideo.source == 'bilibili' || currentVideo.source == 'tencent'"
          style="margin-top:5rem"
        >
          <iframe
            :src="multiSrc"
            scrolling="no"
            frameborder="0"
            :width="videoWidth"
            :height="videoHeight"
            allowfullscreen="true"
          ></iframe>
        </div>
        <div v-else-if="currentVideo.source == 'subo'  || currentVideo.source == 'zdziyuan'">
          <video
            :width="videoWidth"
            :height="videoHeight"
            ref="video"
            style="outline:none;"
            controls
          ></video>
        </div>
      </div>
      <div
        v-if="language && enableSubtitleFeature"
        class="subtitle"
        v-bind:style="{ left: '50%', top: subtitleY, display: showSubtitle}"
      >
        <div
          v-if="videoSubtitle"
          class="subtitle-text"
          v-bind:style="{ fontSize: subtitleFont + 'px'}"
        >
          {{ videoSubtitle }}
          <b-button
            v-if="videoSubtitle && menu=='editSubtitle'"
            class="subtitle-btn"
            variant="dark"
            @click="editSubtitle(currentVideo.id)"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button
            v-if="videoSubtitle && menu=='editSubtitle'"
            class="subtitle-btn"
            variant="dark"
            @click="deleteSubtitle(currentVideo.id)"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>
        </div>
      </div>
      <div
        v-if="enableSubtitleFeature"
        class="video-control"
        v-bind:style="{ left: controlX, top: controlY, opacity: controlOpacity}"
      >
        <div v-if="menu=='main'">
          <b-button
            class="control-btn"
            v-if="!isFullScreen"
            variant="dark"
            @click="fullScreen(currentVideo.id)"
          >
            <b-icon-arrows-fullscreen></b-icon-arrows-fullscreen>
          </b-button>
          <b-button
            class="control-btn"
            v-if="isFullScreen"
            variant="dark"
            @click="exitFullScreen(currentVideo.id)"
          >
            <b-icon-fullscreen-exit></b-icon-fullscreen-exit>
          </b-button>
          <b-button class="control-btn"
                    variant="dark"
                    @click="menu='subtitle'">
            <b-icon-chat-square-dots></b-icon-chat-square-dots>
          </b-button>
        </div>
        <div v-if="menu=='subtitle'">
          <b-button
            class="control-btn"
            v-if="!isFullScreen"
            variant="dark"
            @click="fullScreen(currentVideo.id)"
          >
            <b-icon-arrows-fullscreen></b-icon-arrows-fullscreen>
          </b-button>
          <b-button
            class="control-btn"
            v-if="isFullScreen"
            variant="dark"
            @click="exitFullScreen(currentVideo.id)"
          >
            <b-icon-fullscreen-exit></b-icon-fullscreen-exit>
          </b-button>
          <b-button class="control-btn"
                    variant="dark"
                    @click="language=false">
            <b-icon-eye-slash></b-icon-eye-slash>
          </b-button>
          <b-button class="control-btn"
                    variant="dark"
                    @click="language='EN'">EN</b-button>
          <b-button class="control-btn"
                    variant="dark"
                    @click="language='CN'">中</b-button>
          <b-button
            class="control-btn"
            v-if="isWebsite"
            variant="dark"
            @click="enterEditMode(currentVideo.id)"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button class="control-btn"
                    variant="dark"
                    @click="menu='main'">
            <b-icon-arrow-left></b-icon-arrow-left>
          </b-button>
        </div>
        <div v-if="menu=='editSubtitle'">
          <b-button
            v-if="!videoSubtitle"
            class="control-btn"
            variant="dark"
            @click="addSubtitle(currentVideo.id)"
          >
            <b-icon-textarea-t></b-icon-textarea-t>
          </b-button>
          <b-button class="control-btn"
                    variant="dark"
                    @click="menu='subtitle'">
            <b-icon-arrow-left></b-icon-arrow-left>
          </b-button>
        </div>
      </div>
      <div
        v-if="menu=='editSubtitle' && enableSubtitleFeature && showEditSubtitleControl"
        class="edit-subtitle-control"
        v-bind:style="{ left: editSubtitleX, top: editSubtitleY}"
      >
        <div class="top-10">
          <b-button variant="light"
                    @click="onVideoSeekTo(currentVideo.id, -10)">
            <b-icon-chevron-double-left></b-icon-chevron-double-left>10s
          </b-button>
          <b-button variant="light"
                    @click="onVideoSeekTo(currentVideo.id, -1)">
            <b-icon-chevron-left></b-icon-chevron-left>1s
          </b-button>
          <b-button variant="light"
                    @click="onVideoSeekTo(currentVideo.id, -0.1)">
            <b-icon-chevron-left></b-icon-chevron-left>0.1s
          </b-button>
          <b-button variant="light"
                    @click="onVideoSeekTo(currentVideo.id, 0.1)">
            <b-icon-chevron-right></b-icon-chevron-right>0.1s
          </b-button>
          <b-button variant="light"
                    @click="onVideoSeekTo(currentVideo.id, 1)">
            <b-icon-chevron-right></b-icon-chevron-right>1s
          </b-button>
          <b-button variant="light"
                    @click="onVideoSeekTo(currentVideo.id, 10)">
            <b-icon-chevron-double-right></b-icon-chevron-double-right>10s
          </b-button>
        </div>
        <div class="top-10">
          <b-button
            variant="light"
            @click="editTimeStart(currentVideo.id)"
          >{{ $t('subtitle.setStart') }}</b-button>
          <input
            v-model="editStartTime"
            class="edit-subtitle-time-input"
            :placeholder="$t('subtitle.startTime')"
          >
          <b-button variant="light"
                    v-if="!isClipPlaying"
                    @click="clipPlay(currentVideo.id)">
            <b-icon-play-fill></b-icon-play-fill>
          </b-button>
          <b-button variant="light"
                    v-if="isClipPlaying"
                    @click="clipStop(currentVideo.id)">
            <b-icon-pause-fill></b-icon-pause-fill>
          </b-button>
          <input
            v-model="editEndTime"
            class="edit-subtitle-time-input"
            :placeholder="$t('subtitle.endTime')"
          >
          <b-button
            variant="light"
            @click="editTimeEnd(currentVideo.id)"
          >{{ $t('subtitle.setEnd') }}</b-button>
        </div>
        <div class="top-10">
          <input v-model="editEnText"
                 class="top-10"
                 size="60"
                 placeholder="Edit English subtitle" >
          <input v-model="editCnText"
                 class="top-10"
                 size="60"
                 placeholder="编辑中文字幕" >
        </div>
        <div class="top-10">
          <b-button
            class="lr-20"
            variant="light"
            @click="saveSubtitle(currentVideo.id)"
          >{{ $t('text.save') }}</b-button>
          <b-button
            class="lr-20"
            variant="light"
            @click="showEditSubtitleControl=false"
          >{{ $t('text.abort') }}</b-button>
        </div>
      </div>
      <div class="video-bottom"
           :style="{width: videoWidth + 'px'}">
        <div v-if="!isOpenChatRoom"
             class="video_bottom_container">
          <div
            v-bind:class="[{'mobile-title': isMobileApp}, 'text-full-center','mobile_title_bottom']"
          >
            <h4 class="lr-auto">{{ currentVideo.title }}</h4>
            <h5 class="episodes_num"
                v-show="getVideoList() !== 0">{{currentEpisodes}}</h5>
          </div>
          <div class="oneline">
            <!-- <span class="top-20">
              <button @click="selectPresent(1)"
                      id="small-present"
                      v-bind:class="[selectedPresent==1 && donateDismissCD ? 'petal-reward-btn-large' : 'petal-reward-btn', 'lr-10']">
                <img v-bind:class="[selectedPresent==1 && donateDismissCD ? 'petal-icon-large' : 'petal-icon']"
                     src="static/newVersionImgs/pp1.svg">
              </button>
              <button @click="selectPresent(2)"
                      id="middle-present"
                      v-bind:class="[selectedPresent==2 && donateDismissCD ? 'petal-reward-btn-large' : 'petal-reward-btn', 'lr-10']">
                <img v-bind:class="[selectedPresent==2 && donateDismissCD ? 'petal-icon-large' : 'petal-icon']"
                     src="static/newVersionImgs/pp2.svg">
              </button>
              <button @click="selectPresent(3)"
                      id="big-present"
                      v-bind:class="[selectedPresent==3 && donateDismissCD ? 'petal-reward-btn-large' : 'petal-reward-btn', 'lr-10']">
                <img v-bind:class="[selectedPresent==3 && donateDismissCD ? 'petal-icon-large' : 'petal-icon']"
                     src="static/newVersionImgs/pp3.svg">
              </button>
              <b-tooltip target="small-present"
                         :show.sync="showPresentTips[0]"
                         placement="bottom"
                         triggers="hover focus">
                {{ $t('video.donateClickAgain') }} <br>
                ({{ $t('video.smallPresentTips') }})
              </b-tooltip>
              <b-tooltip target="middle-present"
                         :show.sync="showPresentTips[1]"
                         placement="bottom"
                         triggers="hover focus">
                {{ $t('video.donateClickAgain') }} <br>
                ({{ $t('video.middlePresentTips') }})
              </b-tooltip>
              <b-tooltip target="big-present"
                         :show.sync="showPresentTips[2]"
                         placement="bottom"
                         triggers="hover focus">
                {{ $t('video.donateClickAgain') }} <br>
                ({{ $t('video.bigPresentTips') }})
              </b-tooltip>
            </span>-->
            <div class="mobile_donate">
              <el-popover
                @show="isShowPP = true"
                @hide="isShowPP = false"
                popper-class="popover_pp"
                placement="top"
                :visible-arrow="false"
                trigger="hover"
              >
                <div slot="reference"
                     class="popover_btn">
                  <!-- <div class="pp_title"
                  v-show="isShowPP">{{$t('video.smallGift')}}</div>-->
                  <div
                    class="btn_donate"
                    :style="{background: isShowPP ? '#212121' : ''}"
                    @click="selectPresent(1)"
                  >
                    <img src="static/newVersionImgs/pp1.svg"
                         style="width:22px;" >
                  </div>
                </div>
                <div class="popover_content">
                  <div class="popover_content_item"
                       @click="selectPresent(2)">
                    <!-- <div class="pp_title">{{$t('video.bigGift')}}</div> -->
                    <div class="content_box"
                         :style="{background: isShowPP ? '#212121' : ''}">
                      <img src="static/newVersionImgs/pp3.svg"
                           style="width:28px;" >
                    </div>
                  </div>
                  <div class="popover_content_item"
                       @click="selectPresent(3)">
                    <!-- <div class="pp_title">{{$t('video.middleGift')}}</div> -->
                    <div class="content_box"
                         :style="{background: isShowPP ? '#212121' : ''}">
                      <img src="static/newVersionImgs/pp2.svg"
                           style="width:32px;" >
                    </div>
                  </div>
                </div>
              </el-popover>
            </div>
            <span class="top-20 mobile_dislike pc_dislike">
              <b-button
                @click="showDislikeVideoModal()"
                tabindex="-1"
                v-bind:class="{'mobile-button': isMobileApp, 'lr-10': true, 'dislike-button': true}"
                variant="outline-dark"
              >
                <img v-bind:class="['petal-icon']"
                     src="static/newVersionImgs/dislike_face.svg" >
              </b-button>
            </span>
            <!-- <span v-if="isMobileApp">
              <b-button
                v-b-modal.share-video-modal
                tabindex="-1"
                class="m-10"
                style="height:48px"
                variant="outline-primary"
              >{{ $t('share.shareTo') }}</b-button>
            </span> -->
            <span v-if="!isMobileApp">
              <b-icon-reply-fill id="share-video-popover"
                                 variant="primary"
                                 scale="2"></b-icon-reply-fill>
              <b-popover
                target="share-video-popover"
                no-title
                placement="auto"
                @shown="onShown"
                triggers="hover focus"
              >
                <div class="left">
                  <div style="padding-top: 5px; padding-bottom: 10px;">
                    <button @click="shareWebsite('twitter')"
                            tabindex="-1"
                            class="share-app-btn">
                      <img class="share-website-img"
                           src="static/images/twitter-logo.jpeg" >
                    </button>
                    <button @click="shareWebsite('facebook')"
                            tabindex="-1"
                            class="share-app-btn">
                      <img class="share-website-img"
                           src="static/images/facebook-logo.png" >
                    </button>
                    <button @click="shareWebsite('weibo')"
                            tabindex="-1"
                            class="share-app-btn">
                      <img class="share-website-img"
                           src="static/images/weibo-logo.jpg" >
                    </button>
                    <button @click="shareWebsite('qq')"
                            tabindex="-1"
                            class="share-app-btn">
                      <img class="share-website-img"
                           src="static/images/qq-logo.jpg" >
                    </button>
                  </div>
                  <p>{{ $t('share.websiteShare') }}</p>
                  <div>
                    <p
                      class="left"
                      style="padding-right:10px; padding-top: 1px;"
                    >{{ $t('share.videoURL') }}</p>
                    <input v-model="videoUrl"
                           ref="urlToCopy"
                           class="left"
                           readonly >
                    <button class="copy-btn"
                            @click="copyShareLink">{{ $t('home.copy') }}</button>
                  </div>
                </div>
                <div class="left lr-10">
                  {{ $t('share.wechatQrcode') }}
                  <div class="qrcode"
                       ref="qrCodeUrl"></div>
                </div>
              </b-popover>
            </span>
          </div>
        </div>
        <div v-else
             class="video-bottom-chat-room">
          <ChatContent :userInfo="userInfo"
                       :videoWidth="videoWidth"
                       :isVideoDetail="true"></ChatContent>
        </div>
      </div>
    </div>
    <div :class="['video_right_info',isOpenChatRoom && videoWidth <768?'dn':'']"
         :style="{height:videoHeight+'px'}">
      <div class="video_info_title">
        <h4>{{ currentVideo.title }}</h4>
      </div>
      <div class="list_container">
        <div class="video_list">
          <div
            class="list_num"
            v-show="getVideoList() !== 0"
            v-for="item in getVideoList()"
            :key="item"
            :class="{bgc_active:currentEpisodes === item}"
            @click="playVideoAt(item-1)"
          >{{item}}</div>
          <div class="list_episode"
               v-show="getVideoList() === 0">{{$t('video.episode')}}</div>
        </div>
      </div>
      <div class="petal-div">
        <img
          v-bind:class="[isMobileApp ? 'petal-mobile-icon' : 'petal-icon']"
          src="static/images/petal_icon.png"
        >
        <span
          v-bind:class="[isMobileApp ? 'petal-mobile-text' : 'petal-text',]"
          id="video-balance"
        >{{ showBalance(currentVideo.video_petal_balance) }}</span>
        <b-tooltip
          target="video-balance"
          v-if="currentVideo.video_petal_balance >= 1000"
        >{{ $t('video.videoGotPetal') }} {{ currentVideo.video_petal_balance }} {{ $t('text.petal') }}</b-tooltip>
      </div>
      <div class="video_info"
           v-bind:style="{'margin-top': isMobileApp ? '20px' : 'none'}">
        {{ $t('share.shareBy') }}
        <b>{{ currentVideo.account_name }}</b>
        {{ $t('share.shareAt') }} {{ displayDateTime(currentVideo.share_timestamp) }}
      </div>
    </div>
    <b-modal
      id="share-video-modal"
      title="share-video-modal"
      ref="shareVideoModal"
      centered
      ok-only
      hide-header
      hide-footer
    >
      <div class="share-container">
        <div class="share-title">{{ $t('share.shareVideo') }}</div>
        <div class="p-10">
          <button @click="shareToApp('twitter')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/twitter-logo.jpeg" >
          </button>
          <button @click="shareToApp('wechat')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/wechat-logo.png" >
          </button>
          <button @click="shareToApp('instagram')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/instagram-logo.jpg" >
          </button>
          <button @click="shareToApp('facebook')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/facebook-logo.png" >
          </button>
          <button @click="shareToApp('line')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/line-logo.png" >
          </button>
          <button @click="shareToApp('weibo')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/weibo-logo.jpg" >
          </button>
          <button @click="shareToApp('qq')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/qq-logo.jpg" >
          </button>
          <button @click="shareToApp('whatsapp')"
                  tabindex="-1"
                  class="share-app-btn">
            <img class="share-app-img"
                 src="static/images/whatsapp-logo.jpeg" >
          </button>
        </div>
      </div>
      <div class="text-full-center">
        <b-button
          variant="outline-dark"
          class="m-10"
          @click="closeShareModal"
        >{{ $t('home.close') }}</b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-like-video"
      :visible="donateToVideoAmount!==null"
      title="Donate Petal to this Video"
      @hide="donateToVideoAmount=null"
      @ok="donateVideo()"
    >
      <p>
        {{ $t('account.balance') }}:
        <span
          class="petal-text"
          id="user-balance"
        >{{ showBalance(userBalance) }}</span>
      </p>
      <b-tooltip target="user-balance"
                 placement="top">{{ userBalance }}</b-tooltip>
      <p>
        {{ $t('video.reduceConfirm') }}
        <span
          class="petal-text"
          id="reward-amount"
        >{{ showBalance(Math.abs(donateToVideoAmount), 0) }}</span>?
      </p>
      <b-tooltip target="reward-amount"
                 placement="bottom">{{ donateToVideoAmount }} Petals</b-tooltip>
    </b-modal>
    <b-modal
      id="dislike-video-modal"
      title="Reduce Petal balance to shared Video"
      @ok="donateToVideoAmount=-Math.abs(inputPetalAmount)"
    >
      <div v-if="currentVideo">
        <p>{{ $t('text.name') }}: {{ currentVideo['title'] }}</p>
        <p>{{ $t('share.dislikeVideo') }}</p>
        <p>{{ $t('video.balance') }}: {{ currentVideo['video_petal_balance'] }}</p>
        <p v-if="userInfo">{{ $t('account.balance') }}: {{ userBalance }}</p>
      </div>
      <b-input-group>
        <template v-slot:prepend>
          <b-input-group-text>Petal</b-input-group-text>
        </template>
        <b-form-input v-model="inputPetalAmount"
                      type="number"></b-form-input>
      </b-input-group>
    </b-modal>
    <ChatRoom :userInfo="userInfo"
              :isVideoDetail="true"></ChatRoom>
    <div>
      <b-modal
        id="share-video-modal"
        :title="$t('video.share') + ' ' + $t('video.name')"
        hide-footer
        hide-header
        :visible="sharingVideoURL!==null"
        @hide="$store.commit('SET_SHARING_VIDEO_URL', null)"
      >
        <ShareVideo></ShareVideo>
      </b-modal>
    </div>
    <b-modal
      id="modal-give-petal-to-exist-video"
      :visible="!isMobileScreen && givePetalVideo!==null"
      title="Donate Petal to already shared Video"
      @hide="$store.commit('SET_GIVE_PETAL_VIDEO', null)"
      @ok="donateOrDislikeVideo()"
    >
      <div v-if="givePetalVideo">
        <p>{{ $t('text.name') }}: {{ givePetalVideo['title'] }}</p>
        <p>{{ $t('share.rewardExistedL1') }} {{ givePetalVideo['account_name'] }}.</p>
        <p v-if="givePetalVideo['video_petal_balance']<=0">{{ $t('share.rewardExistedL2') }}</p>
        <p>{{ $t('share.rewardExistedL3') }}</p>
        <p>{{ $t('video.balance') }}: {{ givePetalVideo['video_petal_balance'] }}</p>
        <p v-if="userInfo">{{ $t('account.balance') }}: {{ userBalance }}</p>
      </div>
      <b-input-group>
        <template v-slot:prepend>
          <b-input-group-text>Petal</b-input-group-text>
        </template>
        <b-form-input v-model="donateToShareVideoAmount"
                      type="number"></b-form-input>
      </b-input-group>
    </b-modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters, mapActions } from 'vuex'
import { mmssToSeconds, secondsToMMSS, displayBalance } from '@/utils/common'
import {
    updateSubtitle,
    getSubtitle,
    donateToVideo,
    getUserInfo,
    getVideo,
    checkRemoteVideoSource
} from '@/utils/api'
import ShareVideo from '@/components/ShareVideo'
import TopAlert from '@/components/TopAlert'
import Profile from '@/components/Profile'
import NavBar from '@/components/NavBar'
import ChatRoom from '@/components/ChatRoom'
import ChatContent from '@/components/ChatContent'
import { BASE_URL, SMALL_GIFT, MIDDLE_GIFT, BIG_GIFT } from '@/constants'
import QRCode from 'qrcodejs2'
let Hls = require('hls.js')
export default {
    data() {
        return {
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            isWebsite: process.env.PLATFORM === 'website',
            enableSubtitleFeature: false,
            loading: false,
            donateDismissCD: 0,
            selectedPresent: null,
            page: 1,
            lastVideoNum: 0,
            videoSubtitle: '',
            language: 'EN',
            isFullScreen: false,
            subtitleY: 0,
            subtitleFont: 20,
            showSubtitle: 'none',
            controlX: 0,
            controlY: 0,
            controlOpacity: 1.0,
            menu: 'main',
            currentVideoId: '',
            // Only support English & Chinese for current version. Add more language later.
            editCnText: '',
            editEnText: '',
            editSubtitleX: '50%',
            editSubtitleY: '0px',
            editStartTime: '',
            editEndTime: '',
            isClipPlaying: false,
            subtitleContent: false,
            clipTime: {},
            currentSubtitleIndex: false,
            editSubtitleIndex: false,
            showEditSubtitleControl: false,
            searchCategory: 'tvseries',
            searchLanguage: '',
            donateToVideoAmount: null,
            donateToShareVideoAmount: 10,
            inputPetalAmount: 1000,
            categoryTabIndex: 0,
            languageTabIndex: 0,
            currentDonateAmount: 0,
            showPresentTips: [false, false, false],
            watchStartTime: null,
            watchUpdateTimer: null,
            videoSrc: 'youtube',
            currentEpisodes: 1,
            multiSrc: '',
            isOpenChatRoom: false,
            windowHeight: 1080,
            isShowPP: false,
            isChangeScreen: false,
            videoWidth: 1050,
            videoHeight: 960,
            isMobileScreen: false
        }
    },
    computed: {
        ...mapGetters([
            'videoList',
            'userInfo',
            'sharingVideoURL',
            'userBalance',
            'currentVideo',
            'videoDict',
            'givePetalVideo'
        ]),
        // videoWidth() {
        //     let mw = Math.min(document.body.clientWidth , window.screen.height)
        //     console.log(document.body.clientWidth)
        //     return this.isMobileApp || mw < 640 ? Math.min(mw, 320) : mw
        // },
        // videoHeight() {
        //     let mw = Math.min(window.screen.width, window.screen.height)
        //     return this.isMobileApp || mw < 640 ? 200 : mw / 640 * 360
        // },
        iframeFullscreenMode() {
            return this.enableSubtitleFeature ? 0 : 1
        },
        videoUrl() {
            let url = BASE_URL + '/#' + this.$route.fullPath
            if (this.userInfo && !!this.$route.code) {
                url += '&code=' + this.userInfo.ref_code
            }
            return url
        }
    },
    created() {
        window.onresize = () => {
            this.setvideoSize()
            this.$store.dispatch('setIsPcClient', document.body.clientWidth > 768)
        }
        this.isMobileScreen = document.body.clientWidth < 769
        this.setvideoSize()
        window.scrollTo(0, 0)
        this.$store.commit('SET_CHANGE_NAVBAR_STYLE', true)
        this.windowHeight = window.screen.height
        if (this.isMobileApp) {
            // fullscreenchange, msfullscreenchange, mozfullscreenchange
            window.addEventListener('webkitfullscreenchange', this.changeStatusBar)
        }
        if (this.enableSubtitleFeature) {
            setInterval(this.updateCurrentSubtitle, 200)
            setInterval(this.updateCurrentComponents, 2000)
        }
        this.currentVideoId = this.$route.path.slice('/video/'.length)
        this.videoSrc = this.$route.query.videoSrc
        if (
            this.currentVideo == null ||
      this.currentVideo.id !== this.currentVideoId
        ) {
            if (this.currentVideoId in this.videoDict) {
                this.selectVideo(this.videoDict[this.currentVideoId])
            } else {
                this.updateVideoInfo()
            }
        }
        setInterval(this.updateDonateCD, 1000)
        checkRemoteVideoSource(this.currentVideoId, this.videoSrc)
            .then(res => {
                // console.log('remote video source is ok')
            })
            .catch(errpr => {
                alert(this.$t('video.videoOffline'))
            })
        let getMultiSrc = setInterval(() => {
            if (this.currentVideo) {
                clearInterval(getMultiSrc)
                if (this.currentVideo.source !== 'youtube') {
                    this.multiSrc =
            this.currentVideo.list.length === 0
                ? this.currentVideo.url
                : this.currentVideo.url[this.currentVideo.list[0].id]
                    if (this.currentVideo.video_type === 'Live') {
                        if (this.currentVideo.source === 'tencent') {
                            this.initTencentLive(this.multiSrc)
                        } else if (this.currentVideo.source === 'bilibili') {
                            this.getStream(this.multiSrc)
                        }
                    } else {
                        if (
                            this.currentVideo.source === 'subo' ||
              this.currentVideo.source === 'zdziyuan'
                        ) {
                            this.getStream(this.multiSrc)
                        }
                    }
                }
            }
        }, 500)
        let getCountry = setInterval(() => {
            if (this.$route.name === 'VideoDetail') {
                if (
                    this.$store.state.country === 'CN' &&
          this.currentVideo.source === 'youtube'
                ) {
                    clearInterval(getCountry)
                    this.$router.push('/')
                }
            } else {
                clearInterval(getCountry)
            }
        }, 500)
    },
    beforeDestroy() {
        window.onresize = null

        if (this.isMobileApp) {
            window.removeEventListener(
                'webkitfullscreenchange',
                this.changeStatusBar
            )
        }
    },
    destroyed() {
    },
    description: 'Shared Video',
    methods: {
        ...mapActions([
            'clearVideos',
            'selectVideo',
            'updateVideo',
            'setUserInfo',
            'addActivePoint'
        ]),
        getStream(source) {
            this.$nextTick(() => {
                if (Hls.isSupported()) {
                    let hls = new Hls()
                    hls.attachMedia(this.$refs.video)
                    hls.loadSource(source)
                    hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        console.log('加载成功')
                        this.$refs.video.play()
                    })
                    hls.on(Hls.Events.ERROR, (event, data) => {
                        // 监听出错事件
                        console.log('加载失败')
                    })
                }
            })
        },
        setvideoSize() {
            let mw = Math.min(window.screen.width, window.screen.height)
            this.videoWidth = this.isMobileApp || mw < 640 ? Math.min(mw, 320) : mw
            this.videoHeight = this.isMobileApp || mw < 640 ? 200 : (mw / 640) * 360
            if (document.body.clientWidth < 769) {
                this.videoWidth = document.body.clientWidth
            }
        },
        initTencentLive(vid) {
            this.$nextTick(() => {
                var config = {
                    containerId: 'tx_live_player',
                    vid: vid,
                    livepid: '',
                    width: this.videoWidth,
                    height: this.videoHeight,
                    autoplay: true
                }
                /* global TxvLive:true */
                /* eslint no-undef: "error" */
                var player = new TxvLive(config)
                player.on('ready', function() {})
            })
        },
        changeStatusBar(asd) {
            console.log('fullmoz', document.webkitIsFullScreen)
            /* global AndroidFullScreen:true */
            /* eslint no-undef: "error" */
            if (document.webkitIsFullScreen) {
                AndroidFullScreen.immersiveMode()
            } else {
                AndroidFullScreen.showSystemUI()
            }
        },
        onShown() {
            /* eslint-disable no-new */
            new QRCode(this.$refs.qrCodeUrl, {
                text: this.videoUrl, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        copyShareLink() {
            this.$refs.urlToCopy.select()
            window.document.execCommand('copy')
        },
        donateVideo(amount) {
            let token = localStorage.getItem('user_token')
            if (!amount) {
                // Support dislike only
                amount = -Math.abs(this.donateToVideoAmount)
            }
            if (!amount) {
                alert('Invalid donate amount!')
                return
            }
            if (this.userBalance < Math.abs(amount)) {
                alert(
                    this.$t('account.insufficientPetal', {
                        cost: Math.abs(amount),
                        balance: this.userBalance
                    })
                )
                return
            }
            this.currentDonateAmount += amount
            if (navigator.vibrate) {
                navigator.vibrate(100)
            }
            donateToVideo(this.currentVideo.id, amount, token, this.videoSrc).then(
                res => {
                    let resp = res.data
                    if (resp && resp.status === 'ok') {
                        if (amount < 0) {
                            this.toast(
                                'b-toaster-top-left',
                                'Notification',
                                this.$t('video.reduceVideoPetalSucc')
                            )
                        } else {
                            this.toast(
                                'b-toaster-top-left',
                                'Notification',
                                this.$t('video.donateToVideoSucc')
                            )
                        }
                        this.updateVideo(resp.data)
                        this.selectVideo(resp.data)
                        this.updateUserInfo()
                        if (amount > 0) {
                            this.addActivePoint((Math.min(amount, BIG_GIFT) * 10) / BIG_GIFT)
                        }
                    } else {
                        alert(
                            this.$t('video.donateToVideoFail') + '(' + resp.message + ')'
                        )
                    }
                },
                respError => {
                    alert(this.$t('video.donateToVideoFail') + '(' + respError + ')')
                }
            )
        },
        goHome() {
            this.selectVideo(null)
            this.$router.push({ path: '/' })
        },
        toast(toaster, title, msg, append = false) {
            this.$bvToast.toast(msg, {
                title: title,
                toaster: toaster,
                autoHideDelay: 200,
                solid: true,
                appendToast: append
            })
        },
        donateCountDownChanged(dismissCountDown) {
            this.donateDismissCD = dismissCountDown
        },
        shareWebsite(app) {
            if (!this.isWebsite) {
                return
            }
            let url = BASE_URL + '/#' + this.$route.fullPath
            if (this.userInfo && !!this.$route.code) {
                url += '&code=' + this.userInfo.ref_code
            }
            let encodeURI = encodeURIComponent(url)
            let message = encodeURIComponent(this.currentVideo.title + '#Petal#\n')
            let msgWithURL = message + encodeURI
            if (app === 'twitter') {
                window.open(
                    'https://twitter.com/share?text=' + message + '&url=' + encodeURI
                )
            } else if (app === 'facebook') {
                window.open(
                    'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI
                )
            } else if (app === 'weibo') {
                window.open(
                    'https://service.weibo.com/share/share.php?url=' +
            encodeURI +
            '&title=' +
            message
                )
            } else if (app === 'qq') {
                window.open(
                    'http://connect.qq.com/widget/shareqq/index.html?url=' +
            encodeURI +
            '&sharesource=qzone&title=' +
            msgWithURL +
            '&desc=' +
            msgWithURL +
            '&summary=-'
                )
            }
        },
        shareToApp(app) {
            if (!this.isMobileApp || typeof window.plugins === 'undefined') {
                return
            }
            let url = BASE_URL + '/#' + this.$route.fullPath
            if (this.userInfo && !!this.$route.code) {
                url += '&code=' + this.userInfo.ref_code
            }
            let message = this.currentVideo.title + '#Petal#\n'
            let msgWithURL = message + url
            if (app === 'twitter') {
                window.plugins.socialsharing.shareViaTwitter(
                    message,
                    null /* img */,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'facebook') {
                window.plugins.socialsharing.shareViaFacebookWithPasteMessageHint(
                    msgWithURL,
                    null /* img */,
                    null,
                    'Paste it!',
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'weibo') {
                window.plugins.socialsharing.shareVia(
                    'com.sina.weibo',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'wechat') {
                window.plugins.socialsharing.shareVia(
                    'com.tencent.mm',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'instagram') {
                window.plugins.socialsharing.shareViaInstagram(
                    msgWithURL,
                    null,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'qq') {
                window.plugins.socialsharing.shareVia(
                    'com.tencent.mobileqq',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'line') {
                window.plugins.socialsharing.shareVia(
                    'line',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'whatsapp') {
                window.plugins.socialsharing.shareVia(
                    'whatsapp',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            }
        },
        shareSuccess() {
            console.log('share ok')
        },
        shareFailed(msg) {
            alert(this.$t('text.error') + ': ' + this.$t('share.shareError'))
        },
        closeShareModal() {
            this.$refs.shareVideoModal.hide()
        },
        updateDonateCD() {
            if (this.donateDismissCD > 0) {
                this.donateDismissCD -= 1
            }
        },
        selectPresent(presentIndex) {
            let amount = 0
            this.showPresentTips = [false, false, false]
            if (!this.userInfo) {
                document.body.clientWidth < 769 ? this.$router.push('/login?login=1') : this.$bvModal.show('modal-login')
                return
            }
            switch (presentIndex) {
            case 1:
                amount = SMALL_GIFT
                break
            case 2:
                amount = MIDDLE_GIFT
                break
            case 3:
                amount = BIG_GIFT
                break
            }
            this.donateDismissCD = 5
            if (this.donateDismissCD > 0 && this.selectedPresent === presentIndex) {
                this.donateVideo(amount)
            } else {
                this.selectedPresent = presentIndex
                this.showPresentTips[presentIndex - 1] = true
            }
        },
        getVideoList() {
            return this.currentVideo.video_type === 'Playlist' &&
        this.currentVideo.list.length > 0
                ? this.currentVideo.list.length
                : 0
        },
        playVideoAt(num) {
            if (this.currentVideo.source === 'youtube') {
                let player = this.getPlayer(this.currentVideoId)
                if (!player || !player.hasOwnProperty('playVideoAt')) {
                    return
                }
                player.playVideoAt(Number(num))
            } else {
                if (this.getVideoList() === 0) {
                    this.multiSrc = this.currentVideo.url
                } else {
                    this.multiSrc = this.currentVideo.url[this.currentVideo.list[num].id]
                }
                if (
                    this.currentVideo.source === 'subo' ||
          this.currentVideo.source === 'zdziyuan'
                ) { this.getStream(this.multiSrc) }
            }
            this.currentEpisodes = num + 1
        },
        showDislikeVideoModal() {
            this.showPresentTips = [false, false, false]
            if (this.userInfo) {
                this.$bvModal.show('dislike-video-modal')
            } else {
                document.body.clientWidth < 769 ? this.$router.push('/login?login=1') : this.$bvModal.show('modal-login')
            }
        },
        donateOrDislikeVideo() {
            if (!this.userInfo) {
                alert(this.$t('home.notLoggedIn'))
                return
            }
            let token = localStorage.getItem('user_token')
            donateToVideo(
                this.givePetalVideo.id,
                this.donateToShareVideoAmount,
                token
            ).then(
                res => {
                    if (res.data && res.data.status === 'ok') {
                        if (this.donateToShareVideoAmount < 0) {
                            this.toast(
                                'b-toaster-top-left',
                                'Notification',
                                this.$t('video.reduceVideoPetalSucc')
                            )
                        } else {
                            this.toast(
                                'b-toaster-top-left',
                                'Notification',
                                this.$t('video.donateToVideoSucc')
                            )
                        }
                        this.$store.dispatch('getVideos', ['', 1, 12, false])
                        this.updateUserInfo()
                    } else {
                        alert(
                            this.$t('video.donateToVideoFail') + '(' + res.data.message + ')'
                        )
                    }
                },
                respError => {
                    alert(this.$t('video.donateToVideoFail') + '(' + respError + ')')
                }
            )
        },
        updateUserInfo() {
            getUserInfo()
                .then(res => {
                    this.setUserInfo(res.data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateVideoInfo() {
            getVideo(this.currentVideoId, this.videoSrc)
                .then(res => {
                    this.updateVideo(res.data)
                    this.selectVideo(res.data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        displayDateTime(ts) {
            return new Date(ts * 1000).toLocaleDateString()
        },
        fullScreen(id) {
            this.currentVideoId = id
            this.isFullScreen = true
            this.$refs['video' + id][0].player.f.width = '100%'
            this.$refs['video' + id][0].player.f.height = '100%'

            if (this.isMobileApp && window.StatusBar) {
                window.StatusBar.hide()
            }
            this.setComponentsPosition(id)
        },
        exitFullScreen(id) {
            this.isFullScreen = false
            this.$refs['video' + id][0].player.f.width = this.videoWidth
            this.$refs['video' + id][0].player.f.height = this.videoHeight

            if (this.isMobileApp && window.StatusBar) {
                window.StatusBar.show()
            }
            this.setComponentsPosition(id)
        },
        getVideoClass(id) {
            if (this.isFullScreen) {
                return 'fullScreen'
            } else {
                return 'exitFullScreen'
            }
        },
        updateCurrentComponents() {
            if (this.currentVideoId) {
                this.setComponentsPosition(this.currentVideoId)
            }
        },
        setComponentsPosition(id) {
            let refElement = this.$refs['video_container_' + id][0]
            // let x = refElement.getBoundingClientRect().left
            // let y = refElement.getBoundingClientRect().top
            // let w = refElement.getBoundingClientRect().width
            // let h = refElement.getBoundingClientRect().height
            let b = refElement.getBoundingClientRect().bottom
            let r = refElement.getBoundingClientRect().right
            this.showSubtitle = 'inline'
            this.controlX = r - 20 + 'px'
            let sy = 0
            if (this.isMobileApp) {
                if (this.isFullScreen) {
                    window.scroll(0, 0)
                    this.subtitleFont = 20
                    sy = b - 60 + window.pageYOffset
                    this.subtitleY = sy + 'px'
                    this.controlY = '50%'
                    this.editSubtitleY = '50%'
                } else {
                    this.subtitleFont = 15
                    sy = b - 40 + window.pageYOffset
                    this.subtitleY = sy + 'px'
                    this.editSubtitleY = sy - 70 + 'px'
                    this.controlY = b - 92 + window.pageYOffset + 'px'
                }
            } else {
                if (this.isFullScreen) {
                    this.subtitleFont = 40
                    sy = b - 130 + window.pageYOffset
                    this.subtitleY = sy + 'px'
                    this.controlY = '50%'
                    this.editSubtitleY = '50%'
                } else {
                    this.subtitleFont = 20
                    sy = b - 65 + window.pageYOffset
                    this.subtitleY = sy + 'px'
                    this.editSubtitleY = sy - 70 + 'px'
                    this.controlY = b - 192 + window.pageYOffset + 'px'
                }
            }
        },
        updateCurrentSubtitle() {
            if (this.currentVideoId) {
                this.updateTimeAndSubtitle(this.currentVideoId)
            }
        },
        updateTimeAndSubtitle(id) {
            let player = this.getPlayer(id)
            if (!player) {
                this.videoSubtitle = ''
                return
            }
            let time = player.hasOwnProperty('getCurrentTime')
                ? player.getCurrentTime()
                : 0
            if (this.language) {
                this.videoSubtitle = this.getSubtitleText(time, this.language)
            }
            if (this.isClipPlaying && time >= this.clipTime['end']) {
                player.pauseVideo()
                this.isClipPlaying = false
            }
        },
        onVideoSeekTo(id, timespan) {
            let player = this.getPlayer(id)
            if (!player || !player.hasOwnProperty('getCurrentTime')) {
                return
            }
            let time = player.getCurrentTime() + timespan
            player.seekTo(time)
        },
        enterEditMode(id) {
            if (this.userInfo) {
                this.menu = 'editSubtitle'
                this.fullScreen(id)
            } else {
                alert(this.$t('subtitle.editNotLogin'))
            }
        },
        editTimeStart(id) {
            let player = this.getPlayer(id)
            if (!player || !player.hasOwnProperty('getCurrentTime')) {
                return
            }
            let time = player.getCurrentTime()
            this.editStartTime = secondsToMMSS(time, 1)
        },
        editTimeEnd(id) {
            let player = this.getPlayer(id)
            if (!player || !player.hasOwnProperty('getCurrentTime')) {
                return
            }
            let time = player.getCurrentTime()
            this.editEndTime = secondsToMMSS(time, 1)
        },
        clipPlay(id) {
            let player = this.getPlayer(id)
            if (!player || !player.hasOwnProperty('getCurrentTime')) {
                return
            }
            let time = player.getCurrentTime()
            this.clipTime = {
                start: mmssToSeconds(this.editStartTime),
                end: mmssToSeconds(this.editEndTime)
            }
            if (!this.clipTime['start']) {
                alert(this.$t('text.invalid') + ' ' + this.$t('subtitle.startTime'))
                return
            }
            if (!this.clipTime['end']) {
                alert(this.$t('text.invalid') + ' ' + this.$t('subtitle.endTime'))
                return
            }
            if (this.clipTime['start'] > this.clipTime['end']) {
                alert(this.$t('subtitle.endEarlier'))
                return
            }
            if (time < this.clipTime['start'] || time >= this.clipTime['end']) {
                player.seekTo(this.clipTime['start'])
            }
            player.playVideo()
            this.isClipPlaying = true
        },
        clipStop(id) {
            let player = this.getPlayer(id)
            if (!player || !player.hasOwnProperty('getCurrentTime')) {
                return
            }
            player.pauseVideo()
            this.isClipPlaying = false
        },
        addSubtitle(id) {
            this.editSubtitleIndex = false
            this.editTimeStart(id)
            this.editEndTime = ''
            this.editEnText = ''
            this.editCnText = ''
            this.showEditSubtitleControl = true
        },
        editSubtitle(id) {
            if (this.currentSubtitleIndex === false) {
                return
            }
            this.editSubtitleIndex = this.currentSubtitleIndex
            let item = this.subtitleContent[this.currentSubtitleIndex]
            this.editStartTime = item['start']
            this.editEndTime = item['end']
            if (item['words'].hasOwnProperty('EN')) {
                this.editEnText = item['words']['EN']
            } else {
                this.editEnText = ''
            }
            if (item['words'].hasOwnProperty('CN')) {
                this.editCnText = item['words']['CN']
            } else {
                this.editCnText = ''
            }
            this.showEditSubtitleControl = true
        },
        deleteSubtitle(id) {
            if (this.currentSubtitleIndex === false || !this.subtitleContent) {
                return
            }
            if (confirm('Are you sure you want to delete this subtitle?')) {
                this.subtitleContent.splice(this.currentSubtitleIndex, 1)
                this.saveCurrentSubtitleContent()
            }
        },
        saveSubtitle(id) {
            let words = {
                EN: this.editEnText,
                CN: this.editCnText
            }
            let item = {
                start: this.editStartTime,
                start_sec: mmssToSeconds(this.editStartTime),
                end: this.editEndTime,
                end_sec: mmssToSeconds(this.editEndTime),
                words: words
            }
            if (!this.subtitleContent) {
                this.subtitleContent = []
            }
            if (this.editSubtitleIndex === false) {
                this.subtitleContent.push(item)
            } else {
                this.subtitleContent[this.editSubtitleIndex] = item
            }
            this.subtitleContent.sort((a, b) =>
                a['start_sec'] < b['start_sec'] ? -1 : 1
            )
            this.saveCurrentSubtitleContent()
        },
        saveCurrentSubtitleContent() {
            let ytId = this.getYoutubeID(this.currentVideoId)
            updateSubtitle(ytId, this.subtitleContent)
                .then(res => {
                    if (res.data.status === 'ok') {
                        alert(this.$t('subtitle.updateSucc'))
                        this.showEditSubtitleControl = false
                    } else {
                        alert(res.data.message)
                    }
                })
                .catch(e => {
                    alert(this.$t('subtitle.updateFailed'))
                })
        },
        onPlayVideo(id) {
            let player = this.getPlayer(this.currentVideoId)
            if (player && id !== this.currentVideoId) {
                player.pauseVideo()
            }
            if (this.enableSubtitleFeature) {
                if (!player || id !== this.currentVideoId) {
                    let ytId = this.getYoutubeID(id)
                    getSubtitle(ytId)
                        .then(res => {
                            if (res.data.status === 'ok') {
                                this.subtitleContent = JSON.parse(res.data.data)
                            }
                        })
                        .catch(e => {
                            console.log(e)
                        })
                }
                this.setComponentsPosition(id)
                this.controlOpacity = 0
            }
            this.currentVideoId = id
            if (this.isMobileApp && window.hasOwnProperty('plugins')) {
                window.plugins.insomnia.keepAwake()
            }
            if (this.userInfo) {
                this.watchStartTime = new Date().getTime()
                this.watchUpdateTimer = setInterval(
                    this.updateWatchTime,
                    6 * 60 * 1000
                )
            }
        },
        onStopVideo(id) {
            if (this.enableSubtitleFeature) {
                this.setComponentsPosition(id)
                this.controlOpacity = 1.0
            }
            if (this.isMobileApp && window.hasOwnProperty('plugins')) {
                window.plugins.insomnia.allowSleepAgain()
            }
            this.updateWatchTime()
            if (this.watchUpdateTimer) {
                clearInterval(this.watchUpdateTimer)
            }
        },
        updateWatchTime() {
            if (!this.userInfo) {
                return
            }
            let now = new Date().getTime()
            if (!this.watchStartTime || this.watchStartTime > now) {
                return
            }
            let timeDiff = now - this.watchStartTime
            let addAP = (0.1 * timeDiff) / (6 * 60 * 1000)
            addAP = Math.min(addAP, 0.1)
            this.addActivePoint(addAP)
            this.watchStartTime = now
        },
        getPlayer(id) {
            let refElement = this.$refs['video' + id]
            if (!refElement || !refElement.player) {
                return false
            }
            let player = refElement.player
            return player
        },
        getYoutubeID(id) {
            if (id.startsWith('PL')) {
                let player = this.getPlayer(id)
                return player.getVideoData()['video_id']
            } else {
                return id
            }
        },
        getSubtitleText(time, language) {
            if (!this.subtitleContent) {
                return ''
            }
            this.currentSubtitleIndex = this.searchSubtitleItem(
                this.subtitleContent,
                0,
                this.subtitleContent.length - 1,
                time
            )
            if (this.currentSubtitleIndex === false) {
                return ''
            } else {
                let item = this.subtitleContent[this.currentSubtitleIndex]
                if (item.words.hasOwnProperty(language)) {
                    return item.words[language]
                } else {
                    return ''
                }
            }
        },
        searchSubtitleItem(subtitle, start, end, time) {
            // search subtitle with binary search
            if (
                time < subtitle[start]['start_sec'] ||
        time > subtitle[end]['end_sec']
            ) {
                return false
            }
            if (end - start <= 2) {
                for (let i = start; i <= end; i++) {
                    let item = subtitle[i]
                    if (item['start_sec'] <= time && time <= item['end_sec']) {
                        return i
                    }
                }
                return false
            } else {
                let mid = Math.round((start + end) / 2)
                let item = subtitle[mid]
                if (item['start_sec'] <= time && time <= item['end_sec']) {
                    return mid
                } else if (time < item['start_sec']) {
                    return this.searchSubtitleItem(subtitle, start, mid - 1, time)
                } else if (time > item['end_sec']) {
                    return this.searchSubtitleItem(subtitle, mid + 1, end, time)
                } else {
                    return false
                }
            }
        },
        showBalance(petalBalance, precision = 0) {
            return displayBalance(petalBalance, precision)
        },
        changeChatRoomStatus() {
            this.isOpenChatRoom = !this.isOpenChatRoom
            if (this.isOpenChatRoom) {
                this.$nextTick(() => {
                    this.$children[this.$children.length - 1].optChatRoomContent()
                })
            }
        }
    },
    components: {
        Loading,
        ShareVideo,
        TopAlert,
        Profile,
        ChatRoom,
        ChatContent,
        NavBar
    }
}
</script>
<style lang="scss">
.popover_pp {
  font-size: 14px !important;
  color: #fff;
  width: 31px !important;
  padding: 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;

  .popover_content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .popover_content_item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .pp_title {
        // width: 20%;
        width: 60px;
        text-align: center;
      }

      .content_box {
        width: 50px;
        height: 50px;
        cursor: pointer;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
        margin-left: 5px;
      }
    }
  }
}
</style>
<style scoped lang="scss" >
.video_detail {
  display: flex;
  // align-items: center;
  justify-content: center;
  background-color: #151515;
  margin: 0 !important;

.dn{
    display: none !important;
}
  .navBar_setting {
    display: none;
  }

  .video_right_info {
    margin-top: 130px;
    width: 300px;
    background-color: #202020;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    .video_info_title {
      width: 90%;
      color: #ffffff;
      h4 {
        text-align: left;
        font-size: 19px;
      }
    }
  }
}
.label {
  width: 90%;
  margin-left: 5%;
  font-weight: bold;
  display: flex;
  align-content: center;
  justify-content: space-between;
  font-size: 15px;
  margin-top: 10px;
}
.list_container {
  width: 90%;
  height: 300px;
}
.video_list {
  width: 100%;
  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}
.list_num {
  width: 16%;
  height: 36px;
  margin: 5px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  color: #8f8f8f;
  font-size: 20px;
}
.list_num:hover {
  background: #363636;
  border-radius: 20px;
}
.list_episode {
  cursor: pointer;
  color: #8f8f8f;
  font-size: 15px;
  background: #131313;
  color: #e04315;
  border-radius: 20px;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.bgc_active {
  background: #131313;
  color: #e04315;
  border-radius: 20px;
}
.left {
  float: left;
}
.hide {
  display: none;
}
.qrcode {
  position: relative;
  left: 18%;
  padding-top: 5px;
}
.copy-btn {
  line-height: 20px;
  cursor: pointer;
  background: #4a90e2;
  text-align: center;
  color: #fff;
  font-size: 12px;
}
.share-container {
  text-align: center;
}
.share-title {
  color: #181b3a;
  font-size: 34px;
}
.share-app-img {
  width: 46px;
  height: 46px;
}
.share-website-img {
  width: 40px;
  height: 40px;
}
.share-app-btn {
  background-color: #fff;
  border: white 1px solid;
  border-radius: 8px;
  margin: 2px;
}
.text-full-center {
  width: 50%;
  text-align: left;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  line-height: 25px;
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.m-10 {
  margin: 10px;
}
.p-10 {
  padding: 10px;
}
.top-10 {
  margin-top: 10px;
}
.top-20 {
  margin-top: 20px;
}
.lr-10 {
  margin-left: 10px;
  margin-right: 10px;
}
.lr-20 {
  margin-left: 20px;
  margin-right: 20px;
}
.lr-auto {
  color: #ffffff;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.episodes_num {
  font-size: 28px;
  font-weight: bold;
  color: #e04315;
  margin-left: 20px;
}
.oneline {
  display: flex;
  align-items: center;
  justify-content: space-around;

  .pc_dislike{
      margin:0 15px 0 15px;
  }

  .popover_btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #fff;

    .pp_title {
      font-size: 14px;
    }
  }

  .btn_donate {
    width: 50px;
    height: 50px;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
  }

  .btn_donate:hover {
    background-color: #212121 !important;
  }
}
.search-text {
  margin-left: 30px;
  margin-right: 5px;
}
.search-select {
  width: 150px;
}
.video {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.video_info {
  margin: 20px 5px 5px 5px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #636363;
  line-height: 22px;
}
.video-bottom {
  position: relative;
  top: -8px;
  margin: 0 auto;

  .video_bottom_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 150px;
  }
}
.video-bottom-chat-room {
  height: 280px;
  overflow: scroll;
}
.video-bottom-chat-room::-webkit-scrollbar {
  display: none;
}
.subtitle {
  position: absolute;
  z-index: 10;
  text-align: center;
  transform: translate(-50%, -50%);
}
.subtitle-text {
  color: white;
  padding-left: 5px;
  padding-right: 5px;
  -webkit-text-stroke: 1px black;
  -webkit-text-fill-color: white;
  font-weight: bold;
  white-space: nowrap;
}
.subtitle-btn {
  display: inline;
}
.video-control {
  position: absolute;
  z-index: 20;
  width: 50px;
  transform: translate(-100%, -50%);
  padding: 2px;
}
.edit-subtitle-control {
  position: absolute;
  z-index: 20;
  width: 600px;
  transform: translate(-50%, -50%);
  padding: 2px;
}
.edit-subtitle-time-input {
  width: 120px;
  height: 38px;
}
.control-btn {
  margin-top: 1px;
  margin-bottom: 1px;
  width: 100%;
  opacity: 0.8;
}
.control-btn:hover {
  opacity: 1;
}
.fullScreen {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0px;
  background-color: black;
}
.exitFullScreen {
  position: relative;
  top: auto;
  left: auto;
  margin: auto;
  width: 100%;
  padding-bottom: 0px;
  margin-top: 80px;
  background-color: transparent;
}
.petal-icon {
  width: 30px;
  height: 30px;
}
.petal-mobile-icon {
  width: 32px;
  height: 32px;
}
.mobile-button {
  width: 46px;
  height: 38px;
}
.petal-reward-btn {
  background: transparent;
  border: none;
  padding: 5px;
  width: 46px;
  height: 38px;
  margin: 6px;
}
.petal-reward-btn:focus {
  outline: none;
}
.petal-icon-large {
  width: 36px;
  height: 36px;
}
.petal-reward-btn-large {
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 5px;
  width: 58px;
  height: 50px;
  margin: 0px;
}
.petal-reward-btn-large:focus {
  outline: none;
}
.home-btn {
  position: absolute;
  left: 5%;
  top: 10%;
  background: transparent;
  border: none;
  padding: 5px;
}
.back-to-home {
  display: inline-block;
  height: 30px;
  background-color: #f2f2f2;
  color: #979797;
  border-radius: 18px;
  font-size: 15px;
  text-align: center;
  line-height: 30px;
}
.back-to-home-sapn {
  margin: 10px;
}
.home-btn:focus {
  outline: none;
}
.home-img {
  width: 68px;
  height: 42px;
}
.dislike-button {
  width: 50px;
  height: 50px;
  border: none !important;
  background-color: transparent !important;
  outline: none !important;
  border-radius: 50%;
}
.dislike-button:active {
  outline: none !important;
  border: none !important;
  background-color: #212121 !important;
}
.dislike-button:hover {
  outline: none !important;
  border: none !important;
  background-color: #212121 !important;
}
.petal-div {
}
.petal-text {
  position: relative;
  top: 2px;
  left: 15px;
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fe4987;
  line-height: 24px;
}
.petal-mobile-text {
  color: #fe4987;
  font-size: 17px;
}
.mobile-title {
  margin-top: 35px;
  margin-bottom: 20px;
}
.profile {
  position: absolute;
  right: 50px;
  z-index: 1;
}
.language-div {
  position: absolute;
  right: 3%;
  top: 10%;
}
.popover {
  max-width: 100% !important;
}
>>> .btn-secondary {
  border: none;
  background: transparent;
  color: #4a90e2;
}
@media only screen and (max-width: 768px) {
  .video_detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #202020;
    justify-content: flex-start;

    .navBar_setting {
      width: 100%;
      background: #151515;
      display: flex;
    }

    .navbar {
      display: none;
    }

    .video {
    //   border: 1px solid red;
        margin-top: 40px;
      width: 100%;
  background-color: #151515;
      height: 400px;

      .video-bottom {
        top: 0;
        display: flex;
        align-items: center;
    background-color: #202020;
        justify-content: center;

        .video_bottom_container {
          width: 100%;
    //   border: 1px solid red;
          height: auto;
            margin: 0;
            align-items: flex-start;

          .mobile_title_bottom {
            width: 50%;
            // margin: 0;
          }

          .oneline {
            width: 50%;
            justify-content: flex-start;
            margin: 0 !important;

            .mobile_donate{
                margin-left: 10px;
            }
          }

          .mobile_dislike {
            margin: 0;
          }
        }
      }
    }

    .video_right_info {
      height: auto !important;
      margin: 20px 0 0 0 ;
            margin: 0 !important;
      width: 100%;
        z-index:1;
      .video_info_title {
        display: none;
      }

      .list_container{
          overflow: scroll;
            margin: 0 !important;
            height: 200px;
      }
      .petal-div{
            margin-top: 20px;
      }
    }
  }
  .home-img {
    width: 48px;
    height: 28px;
  }
  .label {
    font-size: 14px;
  }
  .list_num {
    width: 44px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }
  .back-to-home {
    display: inline-block;
    height: 25px;
    background-color: #f2f2f2;
    color: #979797;
    border-radius: 18px;
    font-size: 15px;
    text-align: center;
    line-height: 25px;
  }
  .back-to-home-sapn {
    margin: 10px;
  }
  .home-btn {
    /* position: static; */

    /* float: left; */
  }
  .language-div {
    /* position: static; */
    /* float: right; */
  }
  .profile {
    position: static;
    margin: 0 0px 10px 80%;
  }
  .exitFullScreen {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .modal-content {
    width: 100px;
  }
  .share-title {
    font-size: 20px;
  }
  .petal-text {
    font-size: 15px;
  }
  .text-full-center h4 {
    font-size: 16px;
  }
  .video_info {
    font-size: 14px;
  }
  .mobile-title {
    margin-top: 0px;
  }
  .video-bottom {
    height: 300px;
  }
  .video-bottom-chat-room {
      width: 100%;
    height: 700px;
    background-color: #202020;
    margin-top: 400px;
    padding-bottom: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoDetail.vue